import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Vector extends OBase {
  update () {
    let valTree = this.getVector3Input('Vector');
    let pOutput = this.getGenericObjectOutput('Vector');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        outTree.add(val, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Vector.js